import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const START_IMPERSONATE_USER = "startImpersonateUser";
export const STOP_IMPERSONATE_USER = "stopImpersonateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_TOKEN = "setToken";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  user: {},
  isAuthenticated: !!JwtService.getToken(),
  originalToken: JwtService.getMasterToken(),
  isImpersonating: JwtService.isImpersonating(),
  masterUserId: JwtService.getMasterId(),
  impersonatedUserId: JwtService.getImpersonatedUserId()
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  isImpersonating(state) {
    console.log('isImpersonating', state.isImpersonating);
      return state.isImpersonating;
  },
  impersonatedUserId(state) {
    return state.impersonatedUserId;
  },
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      ApiService.post("auth/login", credentials)
        .then(({ data }) => {
          console.log('login');
          context.commit(SET_TOKEN, data);
          // context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.post("users", { user: credentials })
        .then(({ data }) => {
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, response.data.errors);
          reject(response);
        });
    });
  },
  [VERIFY_AUTH](context) {
    return new Promise((resolve, reject) => {
      if (JwtService.getToken() && JwtService.getToken() !== 'undefined') {
        ApiService.setHeader();
        ApiService.get("users/me")
            .then(({data}) => {
              context.commit(SET_AUTH, data);
              resolve(data);
            })
            .catch(({response}) => {
              // context.commit(SET_ERROR, response.data.errors);
              // reject(response);
              context.commit(PURGE_AUTH);
              resolve();
            });
      } else {
        context.commit(PURGE_AUTH);
        resolve();
      }
    });
  },
  [UPDATE_USER](context, payload) {
    const { email, username, password, image, bio } = payload;
    const user = { email, username, bio, image };
    if (password) {
      user.password = password;
    }

    return ApiService.put("user", user).then(({ data }) => {
      context.commit(SET_AUTH, data);
      return data;
    });
  },
  async [START_IMPERSONATE_USER](context, userId) {
    try {
      console.log('start impersonate user', userId);
      // keep the genuine token only the first time we impersonate
      if (!context.state.isImpersonating) {
        // context.commit("storeOriginalToken", JwtService.getToken());
        context.commit("storeOriginalToken", {
            token: JwtService.getToken(),
            id:    context.state.user.id
        });
      }

      const { data } = await ApiService.post("auth/impersonate", { userId });
      context.commit(SET_TOKEN, data);          // saves new JWT + sets isAuthenticated
      context.commit("setImpersonating", true); // flip flag for UI
      JwtService.setImpersonating(true);
      JwtService.setImpersonatedUserId(userId);
      context.commit("setImpersonatedUserId", userId);
      // refresh /me payload so store.user reflects the impersonated account
      await context.dispatch(VERIFY_AUTH);
    } catch (e) {
      // you already centralise error handling
      const err = e.response ? e.response.data.errors : e;
      context.commit(SET_ERROR, err);
      throw e;
    }
  },

  async [STOP_IMPERSONATE_USER](context) {
    const masterToken = context.state.originalToken;
    if (!masterToken) return;

    JwtService.saveToken(masterToken);
    context.commit(SET_TOKEN, { access_token: masterToken });
    context.commit("clearImpersonation");
    JwtService.clearImpersonatedUserId();
    context.commit("clearImpersonatedUserId");
    await context.dispatch(VERIFY_AUTH);
  }

  // --------------  stopImpersonateUser  --------------
  // async [STOP_IMPERSONATE_USER](context) {
  //   // const savedToken = context.state.originalToken;
  //   const savedToken = JwtService.getToken();
  //   if (!savedToken) {
  //     // nothing to revert, just ignore
  //     return;
  //   }
  //
  //   JwtService.saveToken(savedToken);
  //   context.commit("clearImpersonation"); // reset flags + restore auth status
  //   JwtService.clearImpersonating();
  //   // refresh /me with the genuine user profile
  //   await context.dispatch(VERIFY_AUTH);
  // },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_TOKEN](state, data) {
    JwtService.saveToken(data.access_token);
    state.isAuthenticated = true;
    ApiService.setHeader();
  },
  [SET_AUTH](state, data) {
    state.isAuthenticated = true;
    state.user = data.user;
    console.log('set_auth_user',state.user);
    state.user.name = data.user.firstname;
    state.user.permissions = data.permissions;
    state.user.permissions = ["*"]; // TODO prod remove dummy data
    //state.user.permissions = ["*","contract.fill","contract.log.view"]; // TODO prod remove dummy data
    state.user.groups = data.groups;
    state.user.roles = data.roles;
    state.user.settings = data.settings;
    state.user.estrasf_available = data.estrasf_available;
    state.errors = {};
    // JwtService.saveToken(state.user.token);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    state.masterUserId = 0;
    JwtService.destroyToken();
    JwtService.clearImpersonating();
    JwtService.clearMasterId();
    JwtService.destroyMasterToken();
    JwtService.clearImpersonatedUserId();
    state.impersonatedUserId = 0;
  },
  // helper when we first switch
  storeOriginalToken(state, payload) {
    state.originalToken = payload.token;
    state.masterUserId  = payload.id;
    JwtService.setMasterId(payload.id);
    JwtService.saveMasterToken(payload.token);
  },

  // helper to set/clear impersonation flag
  setImpersonating(state, value) {
    state.isImpersonating = value;
    JwtService.setImpersonating(value);
  },

  clearImpersonation(state) {
    state.isImpersonating = false;
    state.originalToken   = null;
    state.isAuthenticated = true;   // still logged in
    JwtService.clearImpersonating();
    JwtService.clearImpersonatedUserId();
    state.impersonatedUserId = 0;
  },
  setImpersonatedUserId(state, userId) {
    state.impersonatedUserId = userId;
  },
  clearImpersonatedUserId(state) {
    state.impersonatedUserId = 0;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
